import { useEffect, useState } from "react";
import { post } from "../../api/api";
import { getSessionParameter } from '../../utils/session';

const useHome = () => {
    const [name, setName] = useState<string>("Usuário, você não tem perfil vinculado à sua conta, para solicitar acesso à esta aplicação, procure o Administrador.")
    const [access, setAccess] = useState<boolean>(false);

    // Francisco - Trocando para usar cookies
    useEffect(() => {
        if (localStorage.getItem("access_token") !== null) {
            fetchWegasUser();
        }
    }, []);

    // useEffect(() => {
    //     // Francisco
    //     // const token = getSessionParameter("ACCESS_TOKEN");
    //     let token = getSessionParameter("ACCESS_TOKEN");


    //     if (!token) {
    //         token = localStorage.getItem("access_token");
    //     }

    //     if (token) {
    //         fetchWegasUser();
    //     }
    //     // fim 

    //     if (token !== null) {
    //         fetchWegasUser();
    //     } else {
    //     }
    // }, []);

    const fetchWegasUser = () => {
        post<User>('users/screen')
            .then((value: User) => {
                localStorage.setItem("userId", value.id.toString());
                setAccess(value.screens.length > 0);
                if (value.screens.length > 0) {
                    setName(value.name.toString() + ',');
                }
            })
            .catch(error => console.error("Erro ao buscar usuário:", error));
    }

    // const fetchWegasUser = () => {
    //     post<User>('users/screen')
    //         .then((value: User | undefined) => {
    //             if (!value || !value.name || !value.screens) {
    //                 console.warn("Resposta inesperada da API:", value);
    //                 return;
    //             }

    //             localStorage.setItem("userId", value.id?.toString() || '');
    //             setAccess(value.screens.length > 0);

    //             if (value.screens.length > 0) {
    //                 setName(value.name.toString() + ',');
    //             }
    //         })
    //         .catch((err) => {
    //             console.error("Erro ao carregar user/screen:", err);
    //         });
    // }

    return { name, access };
}

export default useHome;